import { render, staticRenderFns } from "./ProfitCenterAdditionalFields.vue?vue&type=template&id=1a32b07a&scoped=true&lang=pug&"
import script from "./ProfitCenterAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitCenterAdditionalFields.vue?vue&type=style&index=0&id=1a32b07a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32b07a",
  null
  
)

export default component.exports